import '../filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.ReviewModeReviewStatusFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  template: JST['backbone/templates/monitoring/filters/review_status/review_mode_review_status_filter']

  name: 'review_status'
  alias: 'Review Status'
  humanize: true

  render: ->
    @$el.html(@template(self: @))
    return this

  getAppliedValues: ->
    return @searchQuery.get('review_status')

  apply: =>
    @searchQuery.setReviewStatus([@$el.find('input[type=radio]:checked').val()])
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)